export const DISTANCE_LEARNING = '/distance-learning'
export const DISTANCE_LEARNING_LESSONS = '/distance-learning-lessons'
export const STUDENT_LESSONS_LIST = '/:ccls_module_id/student-lessons'
